import { Outlet, createFileRoute } from "@tanstack/react-router";

import { APP_ROUTES_FULL } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_FULL.PERFORMANCE)({
    component: RouteComponent,
    staticData: {
        config: {
            title: "performance",
        },
    },
});

function RouteComponent() {
    return <Outlet />;
}
